module.exports = __webpack_public_path__ + "img/logo_light_new.8c9e5578.png";